import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router';
import AuthContext from '../context/AuthContext';
import './Form.css';

const Register = () => {
    const [formData, setFormData] = useState({ name: '', email: '', password: '' });
    const { register } = useContext(AuthContext);
    const navigate = useNavigate();

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();

        const success = await register(formData.name, formData.email, formData.password);

        if (success) {
            navigate('/');
        } else {
            alert('Registration failed. Maybe an account with this email already exists');
        }
    };

    return (
        <div className='form-container'>
            <form onSubmit={onSubmit}>
                <h2>Create account</h2>
                <input type="text" name="name" value={formData.name} onChange={onChange} placeholder='Name' required></input>
                <input type="email" name="email" value={formData.email} onChange={onChange} placeholder='Email' required></input>
                <input type="password" name="password" value={formData.password} onChange={onChange} placeholder='Password' required></input>
                <button type="submit">Register</button>
            </form>
        </div>
    )
}

export default Register;